import { render, staticRenderFns } from "./RevokeButton.vue?vue&type=template&id=649fb7ec&scoped=true"
import script from "./RevokeButton.vue?vue&type=script&lang=js"
export * from "./RevokeButton.vue?vue&type=script&lang=js"
import style0 from "./RevokeButton.vue?vue&type=style&index=0&id=649fb7ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "649fb7ec",
  null
  
)

export default component.exports